import "./scroll.css";
import Content from "./Content";
import ParallaxImage from "./Parallax";
import { useEffect, useState } from "react";
import http from "../../../services/httpServices";
import { Link } from "react-router-dom";
import { baseURL } from "../../../config";
import LoadingIcon from "../../ui/LoadingIcon";
import Button from "../../ui/Button";

export default function Teachers({ layout = "horizontal" }) {
    const [teachers, setTeachers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [seeMore, setSeeMore] = useState(false);
    const fetchTeacher = async () => {
        let params = {
            limit: 100,
        };
        try {
            const { data: res } = await http.get("/api/teacher", {
                params,
            });
            setTeachers(res.results);
            setIsLoading(false);
        } catch (error) {
            //   console.log("err : ", error);
        }
    };
    useEffect(() => {
        fetchTeacher();
    }, []);

    return (
        <>
            {layout === "horizontal" ? (
                <section className="ScrollLine">
                    {isLoading ? (
                        <div className="flex-center-both">
                            <div className="border-2 rounded-md  border-moonBlue-300 dark:border-moonBlue-500 p-10 bg-moonBlue-100 dark:bg-opacity-5 smooth clr-text-primary flex space-x-2 space-x-reverse">
                                <LoadingIcon className="font-h1 text-moonBlue-500" />
                                <span>يتم الآن تحميل المدرسين ...</span>
                            </div>
                        </div>
                    ) : teachers.length < 1 ? (
                        <div className="flex-center-both">
                            <div className="border-2 rounded-md border-earthYellow-300 dark:border-earthYellow-500 p-10 bg-earthYellow-100 dark:bg-opacity-5 smooth clr-text-primary">
                                سيتم اضافة مدرسين هنا قريبًا
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="TeacherScroll relative w-full">
                                <div className="firstLine bg-primary-container smooth ">
                                    <ParallaxImage baseVelocity={-5}>
                                        <Content teachers={teachers} />
                                    </ParallaxImage>
                                </div>
                            </div>
                        </>
                    )}
                </section>
            ) : layout === "grid" ? (
                <section className="">
                    {isLoading ? (
                        <div className="flex-center-both">
                            <div className="border-2 rounded-md  border-moonBlue-300 dark:border-moonBlue-500 p-10 bg-moonBlue-100 dark:bg-opacity-5 smooth clr-text-primary flex space-x-2 space-x-reverse">
                                <LoadingIcon className="font-h1 text-moonBlue-500" />
                                <span>يتم الآن تحميل المدرسين ...</span>
                            </div>
                        </div>
                    ) : teachers.length < 1 ? (
                        <div className="flex-center-both">
                            <div className="border-2 rounded-md border-earthYellow-300 dark:border-earthYellow-500 p-10 bg-earthYellow-100 dark:bg-opacity-5 smooth clr-text-primary">
                                سيتم اضافة مدرسين هنا قريبًا
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="relative z-10 mx-3 md:mx-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 pb-10 gap-5 place-items-center place-content-center">
                                {(seeMore ? teachers : teachers.slice(0, 4)).map(
                                    (teacher, index) => (
                                        <Link to={`/teacher/${teacher.id}`} key={index}>
                                            <div className="bg-moonBlue-100 dark:bg-moonBlue-950 smooth w-[300px] h-[400px] mt-5 px-10 rounded-2xl flex-center-both flex-col py-4">
                                                <div
                                                    className="w-[200px] h-[200px] rounded-tl-3xl rounded-br-3xl overflow-hidden mx-auto"
                                                    key={index}
                                                >
                                                    <img
                                                        src={`${baseURL}/${teacher.picture}`}
                                                        alt={`${teacher.name}_${index}`}
                                                    />
                                                </div>
                                                <div className="flex flex-col space-y-2">
                                                    <span className="text-center text-moonBlue-600 dark:text-moonBlue-200 smooth pt-4 text-2xl font-voxo font-w-bold ">
                                                        {teacher.name}
                                                    </span>
                                                    <span className="text-center clr-text-primary smooth text-lg ">
                                                        {
                                                            teacher.description?.split(
                                                                /(?:\r\n|\r|\n)/
                                                            )[0]
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>
                            {teachers.length > 4 && (
                                <div className="flex relative z-10 justify-center my-10">
                                    <Button
                                        color="rose"
                                        onClick={() => setSeeMore((prev) => !prev)}
                                    >
                                        {seeMore ? "عرض أقل" : "عرض المزيد من المدرسين"}
                                    </Button>
                                </div>
                            )}
                        </>
                    )}
                </section>
            ) : (
                ""
            )}
        </>
    );
}
